import React from 'react';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

function DownloadPdf__(report, reportId, lp){

    const name = reportId;
    // const report = document.getElementById('report');
    // const data = document.getElementById('divTabs' + tabId);
    // const div_height = data.style.height;
    // data.style.height = (data.scrollHeight) + 'px';

    html2canvas(report,{ scale: 1.8 }).then((canvas) => {
        const marginLeft = 3; // 출력 페이지 여백설정
        const marginTop = 3;
        const imgWidth = 204;  // 208
        const pageHeight = 290;

        // const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const m = imgWidth/canvas.width;
        const imgHeight = canvas.height * m;
        const imgPageHeight = Math.round(pageHeight / m)-10;

        let heightLeft = imgHeight;
        let position = marginTop;
        let imageClip="";

        heightLeft -= pageHeight;

        const doc = new jsPDF(lp, 'mm', 'a4');
        
        imageClip = getClipImage(canvas,0,0, canvas.width, imgPageHeight, m);
        doc.addImage(imageClip, 'jpeg', marginLeft , marginTop, imgWidth, pageHeight, '', 'SLOW');
        // const imgData = canvas.toDataURL('image/jpeg'); 
        // doc.addImage(imageClip, 'jpeg', margin, position, imgWidth, imgHeight, '', 'FAST');

        while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            imageClip = getClipImage(canvas, 0, imgPageHeight, canvas.width, imgPageHeight, m);
            doc.addImage(imageClip, 'jpeg', marginLeft , marginTop, imgWidth, pageHeight, '', 'SLOW');
            heightLeft -= pageHeight;
        }

        doc.save('Vulnerablity_'+name+'.pdf');
        doc.close();
    });
    
    //높이 재조정
    // data.style.height = div_height;
};


const  getClipImage = (image, x, y, width, height, m)=>{

    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0,0, width, height);

    ctx.drawImage(image, x, y, width, height,  0, 0, width, height);

    return canvas;
}

const DownloadCode = (url,  _reportId, _reportName, fileExt="pdf") =>{
    const link = document.createElement('a');
    link.href = url;    
    link.style.display = 'none';
    link.setAttribute('download', _reportId+'_'+_reportName+'.'+fileExt); // 다운로드할 파일 이름
    document.body.appendChild(link);
    link.click();
    link.remove();    
}

const DownloadCsv = (resData, _reportId, _reportName) =>{
    const BOM = "\uFEFF";
    const fullCsvString = BOM + resData;
    const url = window.URL.createObjectURL(new Blob([fullCsvString], { type: 'text/csv;charset=euc-kr;' }));
    DownloadCode(url,  _reportId, _reportName, "csv");
}

const DownloadMd = (resData, _reportId, _reportName) =>{
    const BOM = "\uFEFF";
    const fullCsvString = BOM + resData;
    const url = window.URL.createObjectURL(new Blob([fullCsvString], { type: 'text/csv;charset=euc-kr;' }));
    DownloadCode(url,  _reportId, _reportName, "md");
}

const DownloadPdf = (resData, _reportId, _reportName) =>{

    const url = window.URL.createObjectURL(new Blob([resData], { type: 'application/pdf' }));
    DownloadCode(url,  _reportId, _reportName, "pdf");
}

export {DownloadCsv};
export {DownloadMd};
export default DownloadPdf;